import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCZGXKaA09TmdCNwqMW6WsmeCBhlJeZnNY",
  authDomain: "rally-scan.firebaseapp.com",
  projectId: "rally-scan",
  storageBucket: "rally-scan.firebasestorage.app",
  messagingSenderId: "947380440631",
  appId: "1:947380440631:web:9016967d0cf934e0d779b2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db }; 